<ion-header>
    <ion-toolbar>

        <!-- <ion-title mode="ios" role="heading">{{ 'TERMS_HEADER' | translate}}</ion-title> -->

        <ion-buttons slot="end">
            <ion-button
                class="icon-button-accessible-background-contrast"
                (click)="dismiss()">
                <ion-icon
                    slot="icon-only"
                    name="close"></ion-icon>
            </ion-button>
        </ion-buttons>

    </ion-toolbar>
</ion-header>
<ion-content class="ion-padding-start ion-padding-end">
    <!-- <ion-icon name="close" class="ion-float-end" (click)="dismiss()"></ion-icon>
    <br />   -->

    <!-- START END -->
    <div *ngIf="stepName === 'startEnd'">
        <h4 class="ion-text-center">Travel day</h4>
        <p>We'd like to know where you were when the travel day began and ended.</p>

        <p>The "travel day" began at 12:00 AM and ended at 11:59 PM on {{ navParams.data.dayDisplay }}.</p>

        <p>If you were traveling between places when the travel day BEGAN (in a car, on a bus/plane, etc.), please answer with the last place you stopped BEFORE 12:00 AM (even if it was a short stop such as to get gas).</p>
        <p>If you were traveling between places when the travel day ENDED (in a car, on a bus/plane, etc.), please answer with the last place you stopped AFTER 11:59 PM (even if it was a short stop such as to get gas).</p>
    </div>

    <!-- MADE TRIPS -->
    <div *ngIf="stepName === 'madeTrips'">
        <h4>What is a stop?</h4>
        <p>A trip is anytime you travel at least 100 feet and stop at a new location.</p>

        <h4>What are some example trips?</h4>
        <ul>
            <li>Drive to work</li>
            <li>Ride the bus to a store</li>
            <li>Drop a child off at school</li>
            <li>Walk to a park</li>
            <li>Stop at an ATM</li>
        </ul>

        <h4>What if I went out, but didn’t make a stop? (e.g., walk dog)</h4>
        <p>Please report this as 2 trips (see example). Use the most distant place from where you began as your "destination".</p>
    </div>

    <!-- STOPS -->
    <div *ngIf="stepName === 'stops'">

          <h4>What is a stop?</h4>
          <p>A stop is any time you traveled more than 100 feet and conducted an activity. Examples include:</p>

          <ul>
              <li>Getting a coffee on the way to work</li>
              <li>Dropping someone off or picking someone up</li>
              <li>Using a drive-thru ATM</li>
              <li>Arriving at school</li>
          </ul>

          <h4>What is NOT a stop?</h4>
          <ul>
              <li>Going to another store inside the same building (like a mall).</li>
              <li>Going to the end of the driveway to get the mail.</li>
          </ul>

          <h4>What if I switch vehicles?</h4>
          <p>If you switch vehicles (e.g., car to bus, car to another car) you don't need to add the stop unless you do something when you change vehicles like get coffee, use an ATM, etc.</p>
          <p>If you pick up someone or drop someone off (i.e., your travel party changes), please add the stop.</p>



        <!-- <h4>What if I went out, but didn’t make a stop? (e.g., walk dog)</h4>
        <p>Please report this as 2 trips (see example). Use the most distant place from where you began as your "destination".</p> -->
    </div>
</ion-content>
